<template>
  <div>
    <el-upload
      v-if="tips == ''"
      :action="$uploadUrl"
      list-type="picture-card"
      :on-preview="Preview"
      :on-remove="Remove"
      :on-success="Success"
      :file-list="fileList"
      :on-change="handleChange"
      :auto-upload="true"
      accept=".jpg,.jpeg,.png,.png"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-tooltip :content="tips" placement="left" v-else>
      <el-upload
        :action="$uploadUrl"
        list-type="picture-card"
        :on-preview="Preview"
        :on-remove="Remove"
        :on-success="Success"
        :file-list="fileList"
        :on-change="handleChange"
        accept=".jpg,.jpeg,.png,.png"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-tooltip>

    <el-dialog :visible.sync="Dialog" width="680px" top="10vh">
      <img width="100%" :src="DialogImg" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [],
      fileList: [],
      Dialog: false,
      DialogImg: "",
    };
  },
  model: {
    prop: "value",
    event: "upload",
  },
  watch: {
    //内
    imgList: {
      handler(newVal) {
        this.$emit("upload", newVal);
      },
      deep: true,
      immediate: true,
    },
    //外
    value: {
      handler(newVal) {
        if (newVal.length == 0) {
          this.fileList = [];
        } else {
          //   console.log(newVal);
          return false;
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    handleChange(file, fileList) {
      const FileExt = file.name.replace(/.+\./, "");
      if (["png", "jpg", "jpeg"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传.png .jpg .jpeg格式的文件",
        });
        if (this.fileList.length <= 0) {
          this.fileList = [];
        } else {
          this.fileList = fileList.slice(0, 1);
        }
        return false;
      } else {
        this.fileList = fileList;
      }
    },
    //上传成功
    Success(response, file, fileList) {
      let arr = [];
      fileList.forEach((item) => {
        let obj = { url: item.response };
        arr.push(obj);
      });
      this.imgList = arr;
    },
    //照片删除
    Remove(file, fileList) {
      let arr = [];
      fileList.forEach((item) => {
        let obj = { url: item.response };
        arr.push(obj);
      });
      this.imgList = arr;
    },
    //照片预览
    Preview(file) {
      this.DialogImg = file.response;
      this.Dialog = true;
    },
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tips: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
.upload {
  position: relative;
  .tips {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(100%, -50%);
    font-size: 20px;
    color: #183883;
  }
}
</style>